<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">智慧物流解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          目前我国大中城市普遍存在的商品流通“最后一公里”货车进城难、配送成本高、交通拥堵等问题；城市共同配送平台通过改善城市物流节点规划布局、科学确定零售网点卸货时间、加强城区货运车辆管理等措施，实现干线运输与城市配送有效衔接，有效提高城市物流配送的效率，提高客户满意度，降低物流成本。
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          系统业务架构
          <div class="img"><img src="@/assets/img/solution/14/1.png"></div>
          系统主要功能<br>
          市货运服务平台是整个服务平台的核心部分，将客户端和司机端衔接起来，保障整个货运流程顺畅。系统包含运营管理模块、网点门店管理、货运调度管理、呼叫中心、异常处理、城市货运客户端、城市货运司机端、系统管理等模块。<br><br>
          运营管理<br>
          运营管理模块是对后台服务的基础数据进行设置维护，如会员、网点、车辆、货箱、价格等一系列运营参数。<br><br>
          呼叫中心模块<br>
          呼叫中心主要处理两件事：货运下单、处理失联。<br><br>
          异常处理<br>
          在货运任务中难免会有异常的情况出现，异常情况包括：发货方失联、收货方失联、网点无法处理大件货物、费用纠纷等，这些情况都需要网点人员上报给运营中心，交由运营中心处理。<br><br>
          系统管理<br>
          整个系统的统一管理维护模板，包含对系统人员、权限、日志等的操作与设置。<br><br>
          支付结算<br>
          客户端APP集成了第三方支付，如支付宝、微信等（支付宝、微信支付企业账号需要申请）。同时支持各类其他结算方式。<br><br>
          城市货运客户端<br>
          客户端是服务于广大客户，适用安卓和IOS两大移动系统。完成货运下单、网点搜索、在线支付、订单跟踪等主要线上活动。客户端的数据来源于服务平台。<br><br>
          城市货运司机端<br>
          司机端是服务于司机，主要完成司机运单的线上活动，司机端的数据来源于服务平台。<br><br>
          快递系统对接服务<br>
          平台与其他快递系统无缝对接和数据自动交互。具体需要对接的数据如下：系统下单对接、电子运单打印、快件跟踪对接、电子账单对接。 
        </div>
        <div class="title-sub">方案特点</div>
        <div class="text">
          智能化调度<br>
          智能调度改变运输管理，颠覆作业环节<br>
          物流服务信息化<br>
          物流服务移动应用，平台交易，物流专业定制，定位地图<br>
          第三方支付，信用担保，资金安全<br>
          移动支付，面对面担保支付 
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          行业价值<br>
          形成多层次、健全、经济、便捷、安全的城市配送物流体系。<br>
          提升物流配送服务水平，促进物流服务的发展。<br>
          降低物流成本，提高效率。<br>
          政府价值<br>
          绿色配送，缓解城市交通压力、提供便捷服务。<br>
          有效组织城市配送业务人员，提高城市产业竞争力。<br>
          可与新能源电动车合作，节能环保。  
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>